<template>
  <div class="reserve" v-if="isShow">
    <div class="reserve__header">
      <div class="reserve__header__comment">{{ headerComment }}</div>
      <button v-if="!isCast" class="reserve__header__button" @click="reserve()" :disabled="checkeReserveButtonDisable">予約する</button>
    </div>
    <div class="reserve__list" :class="isOpen ? 'open' : 'close'">
      <div class="reserve__list__item" v-for="reserve in reserveList" :key="reserve.id">
        <b-checkbox class="selector" v-if="!isCast" v-model="selectedId" :native-value="reserve.id" :disabled="reserve.reserver != null || reserve.expired"/>
        <span v-html="format(reserve.startAt, reserve.endAt)" :class="reserve.status ? reserve.status.class : ''"/>
        <div v-if="reserve.status && reserve.status.text" class="status" :class="reserve.status.class">{{reserve.status.text}}</div>
        <div v-if="isCast && reserve.status && reserve.reserver" class="reserver">
          <div class="reserver__icon__container">
            <b-image class="icon" :src="reserve.reserver.photoURL" :rounded="true" ratio="1by1"/>
          </div>
          <p class="reserver__nickname">{{reserve.reserver.nickname}}</p>
        </div>
      </div>
    </div>
    <div class="reserve__control">
      <p @click="isOpen = !isOpen">{{controlMessage}}</p>
    </div>
  </div>
</template>

<script>
import * as reserveServices from '@/services/reserveServices';
import * as userServices from '@/services/userServices';
import * as DateTime from '@/utils/date';
import * as modal from '@/utils/modal';
import { analyticsLog } from '@/utils/analytics';

export default {
  name: 'ReserveList',
  props: {
    liveId: { type: String },
    isCast: { type: Boolean },
    castId: { type: String },
    castName: { type: String }
  },
  data() {
    return {
      reserveList: [],
      selectedId: [],
      intervalId: null,
      reserverCount: 0,
      isOpen: false
    };
  },
  async mounted() {
    await this.startReloadInterval();
  },
  computed: {
    isShow() {
      return this.reserveList && this.reserveList.length > 0;
    },
    headerComment() {
      return this.isCast ? "限定配信予約状況" : `限定配信で${this.castName}さんと2人でお話しませんか`;
    },
    controlMessage() {
      return this.isOpen ? "−表示を減らす" : "＋予約枠をもっと見る";
    },
    checkeReserveButtonDisable() {
      return !this.selectedId || this.selectedId.length < 1;
    }
  },
  methods: {
    async startReloadInterval() {
      this.clearReloadInterval();

      await this.findReserveList();
      this.intervalId = setInterval(() => {
        this.findReserveList();
      }, 180000);
    },
    clearReloadInterval() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    async findReserveList() {
      let list = await reserveServices.getReserve(this.liveId);
      this.reserverCount = 0;

      if (list) {
        let reservers = {};
        let criterionDate = (await DateTime.serverDate()).toJSDate();
        criterionDate.setMinutes(criterionDate.getMinutes() + 5);

        for (let item of list) {
          if (item.reserver) this.reserverCount ++;

          if (this.isCast) {
            if (item.reserver) {
              let userId = item.reserver;
              let reserver = reservers[userId];

              if (!reserver) {
                var user = await userServices.getUserDoc(userId);
                if (user) {
                  reserver = {
                    nickname: user.nickname,
                    photoURL: user.photoURL
                  }
                  reservers[userId] = reserver;
                }
              }

              item["reserver"] = reserver;
              item["status"] = {
                text: "予約あり",
                class: "has_reserve"
              };
            } else {
              item["status"] = {
                text: "予約待ち",
                class: "no_reserve"
              };
            }
          } else {
            if (item.reserver) {
              if (item.reserver == this.$store.state.auth.uid) {
                item["status"] = {
                  text: "予約済",
                  class: "my_reserve"
                };
              } else {
                item["status"] = {
                  class: "other_reserve"
                };
              }
            }
          }

          item["expired"] = criterionDate >= item.startAt;
        }
      }

      this.reserveList = list;
      this.$emit("reserverCount", this.reserverCount);
    },
    async reserve() {
      if (this.selectedId.length == 0) {
        return;
      }

      let uid = this.$store.state.auth.uid;
      let point = this.calcReservePoint();

      await this.$store.dispatch('doron/loadDoronDoc', uid);
      let doron = this.$store.getters['doron/doronAmount'];
      let reservePoint = await reserveServices.getReservePoint(uid);

      if (doron < point) {
        modal.openPointLackModal(this);
        return;
      } else if (doron < point + reservePoint) {
        modal.openPointLackModal(this,
          `他の予約中限定配信があるため、<br/>有償ゴールドが不足しています。<br/>有償ゴールドを購入しますか？<br/><br/><scan class="thin">保有有償ゴールド：${doron}pt</scan><br/><scan class="thin">限定配信予約中有償ゴールド：${reservePoint}pt</scan><br/><scan class="thin">不足有償ゴールド：${(point + reservePoint) - doron}pt</scan>`
        );
        return;
      }

      modal.confirm(this, "限定配信予約を完了する",
        `選択した時間で予約を行います。<br/><br/><scan class="thin">消費有償ゴールド：${point}pt</scan><br/><scan有償ゴールド class="thin">現在保有有償ゴールド：${doron}pt</scan><br/><br/>※通信環境など何らかの影響でキャストの限定配信への入場が遅れた場合、遅れが1分未満：50G、以下1分ごとに50Gが払い戻されます。<br/><br/>予約を確定しますか？`,
        null, async () => {
          await this.execReserve();
        }
      );
    },
    async execReserve() {
      this.clearReloadInterval();

      let result = await reserveServices.reserve(this.$store.state.auth.uid, this.liveId, this.selectedId);
      analyticsLog('視聴画面【表示時】', {'キャストID': this.castId, '予約選択数': this.selectedId ? this.selectedId.length : 0});
      if (result) {
        document.querySelectorAll(`.reserve__list__item input[type='checkbox']`).forEach(elem => {
          elem.checked = false;
        });
        this.selectedId = [];
      } else {
        modal.alert(this, "予約エラー", "選択した予約枠の一部または全部が<br/>予約済みもしくは期限切れのため、<br/>予約を完了できませんでした。");
      }

      await this.startReloadInterval();
    },
    calcReservePoint() {
      let point = 0;
      for (let id of this.selectedId) {
        for (let reserve of this.reserveList) {
          if (reserve.id == id) {
            point += reserve.reservePoint;
            break;
          }
        }
      }
      return point;
    },
    format(startAt, endAt) {
      var text = DateTime.formatJSDate("MM/dd", startAt);
      text += "&nbsp;&nbsp;"
      text += DateTime.formatJSDate("HH:mm〜", startAt);
      text += DateTime.formatJSDate("HH:mm", endAt);
      return text;
    }
  },
  beforeDestroy() {
    this.clearReloadInterval();
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/reserve-list.scss';
</style>
